import axios from 'axios';

// Definimos la URL base con un respaldo (fallback) hacia tu entorno de producción
// Si la variable no se carga en Netlify, el sistema usará la URL de Railway directamente
const rawBaseURL = import.meta.env.VITE_BACKEND_URL || 'https://tbt-backend-logistica-production-c018.up.railway.app';
const baseURL = rawBaseURL.replace(/\/+$/, '').replace(/\/api$/, '');

const api = axios.create({
  baseURL: `${baseURL}/api`, 
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    'Accept': 'application/json',
  }
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('tbt_token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
}, (error) => {
  return Promise.reject(error);
});

export default api;